import React from 'react';
import LocationTemplate from './LocationTemplate';

const FayettevillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Fayetteville"
      stateName="North Carolina"
      countyName="Cumberland"
      zipCodes={["28301", "28302", "28303", "28304", "28305", "28306", "28307", "28308", "28309", "28310", "28311", "28312", "28314"]}
      latitude={35.0527}
      longitude={-78.8784}
      population={208501}
      historicalFact="Home to Fort Bragg (now Fort Liberty), one of the largest military installations in the world."
      nearbyTowns={[
        "Spring Lake, NC",
        "Hope Mills, NC",
        "Raeford, NC",
        "Eastover, NC",
        "Linden, NC",
        "Dunn, NC",
        "Lillington, NC",
        "Sanford, NC"
      ]}
    />
  );
};

export default FayettevillePage;